<template>
  <div class="group_selector_local">
    <select v-model="orgId" :disabled="!orgSelectable" title="기관 선택" @change="changeOrg">
      <option value="">전체</option>
      <option
          v-for="(item, index) in orgList"
          :value="item.orgCode"
          :key="index"
      >{{ item.orgName }}
      </option>
    </select>

    <select v-model="stateId" :disabled="!stateSelectable" title="지역 선택" @change="changeState">
      <option value="">전체</option>
      <option
          v-for="(item, index) in stateList"
          :value="item.stateId"
          :key="index"
      >{{ item.stateName }}
      </option>
    </select>

    <select v-model="cityId" :disabled="!citySelectable" title="도시 선택" @change="changeCity">
      <option value="">전체</option>
      <template v-if="cityList">
        <option
            v-for="(item, index) in cityList"
            :value="item.cityId"
            :key="index"
        >{{ item.cityName }}
        </option>
      </template>
    </select>

    <select v-if="useGroup" :disabled="!groupSelectable" v-model="groupId" title="그룹 선택" @change="changeGroup">
      <option value="">전체</option>
      <template v-if="groupList">
        <option
            v-for="(item, index) in groupList"
            :value="item.groupId"
            :key="index"
        >{{ item.groupName }}
        </option>
      </template>
    </select>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  props: {
    permissionCode: String,
    initArea: String, // LH 서울특별시 종로구
    useGroup: {
      type: Boolean,
      default: true
    }
  },
  data() {
    let initGroupArr = [];
    if (this.initArea) {
      const areaArr = this.initArea.split(" ");
      const org = this.$store.state.groupData.find(
          item => item.orgName === areaArr[0]
      );
      const state = org
          ? org.states.find(item => item.stateName === areaArr[1])
          : null;
      const city = state
          ? state.cities.find(item => item.cityName === areaArr[2])
          : null;
      if (org) {
        initGroupArr.push(org.orgCode);
      }
      if (state) {
        initGroupArr.push(state.stateId);
      }
      if (city) {
        initGroupArr.push(city.cityId);
      }
    } else {
      initGroupArr = _.map(
          ["org", "state", "city", "group"],
          key =>
              this.$store.state.permissions[this.permissionCode].region[key].baseId
      );
    }

    return {
      orgId: initGroupArr[0] || "",
      stateId: initGroupArr[1] || "",
      cityId: initGroupArr[2] || "",
      groupId: initGroupArr[3] || "",
    };
  },
  watch: {
    // orgId() {
    //   this.stateId = "";
    // },
    // stateId() {
    //   this.cityId = "";
    // },
    // cityId() {
    //   this.groupId = "";
    // },
  },
  computed: {
    ...mapState(["groupData", "permissions"]),
    permissionInfo() {
      return this.permissions[this.permissionCode] || {};
    },
    orgSelectable() {
      return this.permissionInfo.region.org.modifiable;
    },
    stateSelectable() {
      return this.permissionInfo.region.state.modifiable;
    },
    citySelectable() {
      return this.permissionInfo.region.city.modifiable;
    },
    groupSelectable() {
      return this.permissionInfo.region.group.modifiable;
    },

    baseData() {
      this.orgData;
    },

    // 기관이 있는 지역만 필터
    orgList() {
      return this.groupData;
    },
    stateList() {
      if (!this.orgItem) {
        return null;
      }
      return this.orgItem.states;
    },
    cityList() {
      if (!this.stateItem) {
        return null;
      }
      return this.stateItem.cities;
    },
    groupList() {
      if (!this.cityItem) {
        return null;
      }
      return this.cityItem.groups;
    },

    orgItem() {
      if (!this.orgId) {
        return null;
      }
      return _.find(this.groupData, {orgCode: this.orgId});
    },
    stateItem() {
      if (!this.stateId) {
        return null;
      }
      return _.find(this.stateList, {stateId: this.stateId});
    },
    cityItem() {
      if (!this.stateItem || !this.cityId) {
        return null;
      }
      return _.find(this.cityList, {cityId: this.cityId});
    },
    groupItem() {
      if (!this.cityItem || !this.groupId) {
        return null;
      }
      return _.find(this.cityItem.groups, {groupId: this.groupId});
    }
  },
  methods: {
    // public
    getData() {
      return {
        orgId: this.orgId,
        stateId: this.stateId,
        cityId: this.cityId,
        groupId: this.groupId
      };
    },
    getFullData() {
      return {
        org: this.orgItem,
        state: this.stateItem,
        city: this.cityItem,
        group: this.groupItem
      };
    },
    changeOrg() {
      this.stateId = "";
      this.cityId = "";
      this.groupId = "";
    },
    changeState() {
      this.cityId = "";
      this.groupId = "";
    },
    changeCity() {
      this.groupId = "";
    },
    changeGroup() {
    },
    applyData(orgCode, state, city, group) {
      this.orgId = orgCode;
      this.stateId = state;
      this.cityId = city;
      this.groupId = group;
    },
  },
};
</script>
